import { updatePortofolio } from "../../../api/portofolioAPI";
import Swal from 'sweetalert2';

export const handleUpdate = async (
  e,
  id,
  name,
  imageUrl,
  link,
  status,
  type,
  toggleModal,
  category = ""
) => {
  e.preventDefault();

  if (!name) {
    Swal.fire({ icon: 'error', title: 'Oops...', text: 'Nama portofolio wajib diisi' });
    return;
  }

  const updatedFields = {
    name,
    img: imageUrl,
    link,
    status,
    type,
    category,
  };

  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: "You are about to update the portofolio's information.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, update it!'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    Swal.fire({
      title: 'Loading...',
      text: 'Please wait while we update the portofolio.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    await updatePortofolio(id, updatedFields);

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Portofolio updated successfully',
    }).then(() => {
      window.location.reload();
    });

    toggleModal();
  } catch (error) {
    console.error("Failed to update portofolio:", error.response ? error.response.data : error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to update portofolio',
    });
  }
};
